import { emitter } from '@/plugins/mitt.js';
import state from '../state.js';

/**
 * Sets or removes a class depending on the current focus state.
 *
 * @param {Element} el - The DOM element which carries the directive.
 * @param {Object} binding - Data given to the directive.
 * @param {Boolean} binding.value - The desired state of the focus.
 */
function updated(el, binding) {
  if (binding.value === binding.oldValue) {
    // Prevent accidental closing when a component updates because of prop changes.
    return;
  }

  if (binding.value) {
    el.classList.add('focus-item');
  } else {
    el.classList.remove('focus-item');
  }

  state.variant = binding.arg || null;
  state.enabled = !!binding.value;

  emitter.emit('check-focus');
}

/**
 * A directive which adds specific styles to an element to highlight it in the DOM.
 */
export default {
  name: 'focus-item',

  beforeMount: updated,
  updated,
  unmounted() {
    state.variant = null;
    state.enabled = false;
  },
};
